<template>
    <div class="order-video-mod rel">
        <h2>{{ $t('video.otherVideos') }}</h2>
        <router-link class="ui-link" :to="{path: '/user/cloud-library/' }">
            <span class="text">{{ $t('video.more') }}</span><span class="ui-icon icon-icon_arrow-right"></span>
        </router-link>
        <a class="ui-link"></a>
        <ul class="video-list rel">
            <div class="video-lint-content">
                <v-touch v-on:swipeleft="swipeleftAction" v-on:swiperight="swiperightAction">
                    <div class="videos-content-warpper">
                        <div class="item-mod"  v-for=" ( video, index ) in orderVideoList " :key="index">
                            <div
                            :class="[ videoId == video.id ? 'item active' : 'item' ]"
                            :videoId="video.id" v-lazy:background-image="{
                                src: `${video.coverUrl}small.jpg`,
                                error: defaultCover,
                                loading: defaultCover
                            }">
                                <router-link :to="{path: '/user/play/', query: { videoId: video.id }}">
                                    <p class="device">{{ video.deviceName ? video.deviceName : currentDevice }}</p>
                                    <div class="cover">
                                        <span class="icon-icon_play-2 play-icon"></span>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </v-touch>
                <a v-bind:class="[ ( !prevClickState || !prevRepetClick ) ? 'owl-prev disabled': 'owl-prev']" v-on:click="prevOtherVideo"><span class="arrows prev-button icon-icon_arrow-left"></span></a>
                <a v-bind:class="[ ( !nextClickState || !nextRepetClick ) ? 'owl-next disabled': 'owl-next']" v-on:click="nextOtherVideo"><span class="arrows next-button icon-icon_arrow-right"></span></a>
            </div>
        </ul>
    </div>
</template>

<script>

import { getOrtherList } from '@/api/cloud';
import defaultCover from 'IMAGE/cloud/default-cover.jpg';

export default {

    data () {

        return {

            videoId: this.$route.query.videoId,
            orderVideoList: [ this.videoInfo ],
            item: 0,
            prevOtherState: true,
            nextOtherState: true,
            prevClickState: true,
            nextClickState: true,
            prevRepetClick: true,
            nextRepetClick: true,
            screenWidth: document.body.clientWidth,
            showItem: 4,
            defaultCover

        };

    },

    props: {

        videoInfo: {
            type: Object,
            required: true
        },
        deviceList: {
            type: Object,
            required: true
        },
        currentDevice: String

    },

    mounted () {

        const that = this;

        window.onresize = () => {

            return (() => {

                that.screenWidth = document.body.clientWidth;

            })();

        };

        this.mediaAction( this.screenWidth );

    },

    created () {

        this.getOrtherVideos( this.videoId, 5, 'desc', true );

    },

    methods: {

        async getOrtherVideos ( videoId, count, order, first ) {

            await getOrtherList({

                'videoId': videoId,
                'count': count,
                'order_way': order

            }).then( data => {

                data.videos.forEach( element => {

                    element.deviceName = this.deviceList[element.uid];
                    
                });

                if ( order === 'desc' ) {

                    if ( !data.videos.length ) {

                        this.nextOtherState = false;

                    } else {

                        this.orderVideoList = this.orderVideoList.concat( data.videos );

                    }

                    this.nextRepetClick = true;
                    
                } else {

                    if ( !data.videos.length ) {

                        this.prevOtherState = false;

                    } else {

                        this.orderVideoList = data.videos.concat( this.orderVideoList );

                    }

                    this.prevRepetClick = true;

                }

                if ( first && this.orderVideoList.length < this.showItem ) {

                    if ( order === 'asc' ) {

                        this.prevClickState = false;
                        this.nextClickState = false;

                    } else {

                        this.getOrtherVideos( this.videoId, this.showItem - this.orderVideoList.length, 'asc', true );

                    }

                }

            }).catch( err => {

                console.error( err );

            });

        },

        swipeleftAction ( ) {

            this.nextOtherVideo();

        },

        prevOtherVideo () {

            let orderId = this.orderVideoList.length ? this.orderVideoList[0][ 'id' ] : 0;

            if ( this.prevOtherVideo && Math.abs( this.item ) <= 2 ) {

                this.prevRepetClick = false;

                this.getOrtherVideos( orderId, 1, 'asc' );

            }

            this.nextClickState = true;

            if ( this.item ) {

                this.item++;
                this.prevClickState = true;

            } else if ( !this.prevOtherState ) {

                this.prevClickState = false;

            }

            this.setTransValue();

        },

        swiperightAction ( ) {

            this.prevOtherVideo();

        },

        nextOtherVideo () {
            
            let orderId = this.orderVideoList.length ? this.orderVideoList[ this.orderVideoList.length - 1 ][ 'id' ] : 0;

            if ( this.nextOtherState && Math.abs( this.item ) + this.showItem + 2 >= this.orderVideoList.length ) {

                this.nextRepetClick = false;

                this.getOrtherVideos( orderId, 1, 'desc' );

            }

            this.prevClickState = true;

            if ( Math.abs( this.item ) + this.showItem === this.orderVideoList.length ) {

                this.nextClickState = false;

            } else {

                this.item--;
                this.nextClickState = true;

            }

            this.setTransValue();

        },

        setTransValue () {

            let itemWidth = $( '.videos-content-warpper .item-mod ' ).width();

            let transValue = itemWidth * this.item;

            $( '.videos-content-warpper' ).css({
                'transform': `translate3d( ${transValue}px, 0px, 0px )`,
                '-moz-transform': `translate3d( ${transValue}px, 0px, 0px )`,
                '-webkit-transform': `translate3d( ${transValue}px, 0px, 0px )`,
                '-ms-transform': `translate3d( ${transValue}px, 0px, 0px )`,
                '-o-transform': `translate3d( ${transValue}px, 0px, 0px )`
            });

        },

        mediaAction ( val ) {

            let setTime;

            setTime && clearTimeout( setTime );

            setTime = setTimeout(() => {

                if ( val <= 1182 ) {

                    this.showItem = 2;

                } else {

                    this.showItem = 4;

                }

                if ( this.orderVideoList.length < this.showItem ) {

                    this.prevClickState = false;
                    this.nextClickState = false;

                } else {

                    this.prevClickState = true;
                    this.nextClickState = true;

                }

                this.setTransValue();
                
            }, 1500 );

        }

    },

    watch: {

        videoInfo ( val ) {

            this.videoId = this.$route.query.videoId;

        }

    }
        
};
</script>

<style lang="less">

    .order-video-mod{
        margin-bottom: 1rem;
    }
    .order-video-mod h2{
        font-size: .22rem;
        font-weight: 500;
        margin-bottom: .2rem;
    }
    .order-video-mod .ui-link{
        position: absolute;
        right: 0;
        top: .06rem;
    }
    #app .video-list .owl-prev, #app .video-list .owl-next{
        font-size: .24rem;
        position: absolute;
        margin-top: -0.32rem;
        top: 50%;
        padding: .2rem 0;
        cursor: pointer;
        color: #333;
        background-color: transparent;
    }
    #app .order-video-mod .video-list{
        cursor: pointer;
    }
    #app .video-list .owl-prev{
        left: 0;
    }
    #app .video-list .owl-next{
        right: 0;
    }
    #app .video-list .owl-prev:hover, #app .video-list .owl-next:hover{
        color: @theme;
    }
    .video-lint-content{
        width: 11.4rem;
        margin: 0 auto;
        overflow: hidden;
    }
    .video-lint-content .videos-content-warpper{
        font-size: 0;
        width: 10000rem;
        transition: 0.25s;
    }
    .video-lint-content .item{
        width: 2.7rem;
        height: 1.44rem;
        border-radius: .1rem;
        border: 2px solid #fff;
        background-color: #f1f1f1;
        display: inline-block;
        cursor: pointer;
        position: relative;
        margin: 0 0.06rem;
    }
    .video-lint-content .item img{ width: 100%; height: 100%; border-radius: .1rem; }
    .video-lint-content .item .cover{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
        opacity: 0;
        -webkit-transition: opacity 0.35s;
        transition: opacity 0.35s;
        border-radius: .1rem;
        border: 2px solid @theme;
    }
    .video-lint-content .owl-item{
        margin-right: .1rem;
    }
    .video-lint-content .item .play-icon{
        font-size: .3rem;
        position: absolute;
        top: 85%;
        left: 50%;
        -webkit-transform: translate(-50%,-50%);
        -moz-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        -webkit-transition: top 0.35s;
        -moz-transition: top 0.35s;
        -ms-transition: top 0.35s;
        transition: top 0.35s;
        color: #fff;
        font-weight: 500;
    }
    .videos-content-warpper .device{
        position: absolute;
        padding: 0.2rem 0.1rem 0.05rem;
        bottom: 0;
        width: 100%;
        font-weight: 500;
        color: #fff;
        font-size: 0.14rem;
        box-sizing: border-box;
        text-align: right;
        background: -webkit-linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
        border-bottom-left-radius: .1rem;
        border-bottom-right-radius: .1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .videos-content-warpper .item{
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .video-lint-content .item:hover .play-icon,
    .video-lint-content .item.active .play-icon{
        top: 50%;
    }
    .video-lint-content .item:hover .cover,
    .video-lint-content .item.active .cover{ opacity: .4; }
    .video-lint-content .item a{ display: block; width: 100%; height: 100%; }
    .video-lint-content .item-mod{
        display: inline-block;
        box-sizing: border-box;
    }

    .video-lint-content .disabled{
        opacity: .5;
        pointer-events: none;
        cursor: not-allowed;
    }

    @media screen and ( max-width: 1199px ) {

        #app .video-list .owl-prev:hover, #app .video-list .owl-next:hover{
            color: #fff;
        }

        .order-video-mod h2{
            color: #333;
            font-weight: 500;
            font-size: .36rem;
            padding: 0 15px;
            margin-bottom: .44rem;
            line-height: 1;
        }

        .order-video-mod .ui-link{
            right: 15px;
        }

        .order-video-mod .ui-link .ui-icon{
            font-size: 0.22rem;
            transform: scale(0.7) translateY(12%);
        }

        .video-lint-content{
            width: 6.6rem;
            height: auto;
            overflow-x: hidden;
        }

        .order-video-mod .video-list{
            overflow-x: hidden;
            padding-top: 0 !important;
        }

        .video-lint-content .item{
            width: 3.12rem;
            height: 1.66rem;
            border-radius: .2rem;
        }

        #app .video-list .owl-prev, #app .video-list .owl-next{
            background-color: #7C7F80;
            color: #fff;
            line-height: .88rem;
            width: .88rem;
            margin: 0;
            position: absolute;
            margin-top: -0.44rem;
            top: 50%;
            border-radius: 50%;
            padding: 0 .2rem;
            box-sizing: border-box;
        }
        #app .video-list .owl-prev{
            left: -.4rem;
            text-align: right;
        }
        #app .video-list .owl-next{
            right: -.4rem;
            text-align: left;
        }

        .order-video-mod{
            margin-bottom: .85rem;
        }

    }

    @media screen and ( min-width: 319px ) and (  max-width: 400px ) {
        .video-lint-content{
            width: 6.6rem;
        }
    }

    @media screen and ( min-width: 600px ) and (  max-width: 780px ) {
        .video-lint-content{
            width: 6.52rem;
        }
    }

    @media screen and ( min-width: 780px ) and (  max-width: 900px ) {
        .video-lint-content{
            width: 6.7rem;
        }
        
        .video-lint-content .item{
            width: 3.2rem;
            height: 1.7rem;
        }
    }

    @media screen and ( min-width: 900px ) and (  max-width: 1199px ) {
        
        .video-lint-content{
            width: 8.7rem;
        }
        
        .video-lint-content .item{
            width: 4.2rem;
            height: 2.24rem;
        }
    
    }

</style>



// WEBPACK FOOTER //
// src/view/videos/otherVideos.vue